import { Outlet, Link } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Button from "@mui/material/Button";
// import { createTheme } from "@mui/material/styles";

import Signup from "./components/auth/signup.js";
import Login from "./components/auth/login.js";
import OtpLogin from "./components/auth/otplogin.js";
import Reset from "./components/auth/resetpassword.js";
import Forgot from "./components/auth/forgotpassword.js";
import CustomSnackbar from "./components/shared/snackbar";
import Activateuser from "./components/auth/activateuser";
import Home from "./components/home";
import Overview from "./components/overview";
import Support from "./components/support";
import Profile from "./components/profile";
//import Packages from "./components/packages";
// import CustomizePackages from "./components/packagescustomize";
// import Checkout from "./components/checkout";
// import Status from "./components/auth/status.js";
import Footer from "./components/shared/footer.js";
// import Buffer from "./components/shared/Buffer.js";
// import Deleteaccount from "./components/shared/Deleteaccount.js";
import Files from "./components/filefolder/Files.js";
import Favorites from "./components/files/Favorites.js";
import RecycleBin from "./components/files/Recyclebin.js";
import Contactus from "./components/pages/Contactus.js";
import Shipping from "./components/pages/Shipping.js";
import Cancellation from "./components/pages/Cancellation.js";
import Termscondition from "./components/pages/Termscondition.js";
import Privacy from "./components/pages/Privacy.js";
import Pricing from "./components/pages/Pricing.js";
import Landingpage from "./components/pages/Landingpage.js";
import AboutCompany from "./components/pages/AboutCompany.js";
import { UserProvider } from "./components/auth/userContext.js";
import Carrer from "./components/shared/Carrer.js";
// import CloudService from "./components/pages/CloudService.js";
import HelpCenter from "./components/pages/HelpCenter.js";
import Testominal from "./components/pages/Testominal.js";
import BlogsAndUpdates from "./components/pages/BlogsAndUpdates.js";
import SelectPlan from "./components/CustomerOnboarding/SelectPlan.js";
import AddressDetails from "./components/CustomerOnboarding/AddressDetails.js";
import Confirmation from "./components/CustomerOnboarding/Confirmation.js";
import Payment from "./components/CustomerOnboarding/Payment.js";
import DecidingScreen from "./components/pages/DecidingScreen.js";
import ParentInformation from "./components/pages/ParentInformation.js";
import ChildSignup from "./components/auth/ChildSignup.js";
import NotFound from "./components/pages/NotFound.js";
import ProductPage from "./components/pages/ProductPage.js";
import TrendingSwiper from "./components/pages/TrendingSwiper.js";
import VinayKumar from "./components/Employee/VinayKumar.js";
import Prabhu from "./components/Employee/Prabhu.js";
import DownloadExe from "./components/DownloadExe.js";
import PaymentPlan from "./components/CustomerOnboarding/PaymentPlan.js";
import PaymentProceed from "./components/CustomerOnboarding/PaymentProceed.js";
import SignupPlan from "./components/auth/SignupPlan.js";
import Plans from "./components/plans/Plans.js";
import HomePage from "./components/homepage/HomePage.js";
import DownloadWindow from "./components/pages/DownloadWindow.js";
import PaymentHome from "./components/CustomerOnboarding/PaymentHome.js";
import { paths } from "./routes/paths.js";
import DashSupport from "./dashboard/DashSupport.js";
import DashHome from "./dashboard/DashboardHome/DashHome.js";
import DashProfile from "./dashboard/DashProfile.js";
import DashPlans from "./dashboard/DashboardPlans/DashPlans.js";
import MegaMenuView from "./dashboard/main.js";
import EmailAndOtp from "./components/auth/SignUp/EmailAndOtp.js";
import UserPass from "./components/auth/SignUp/UserPass.js";
import UserEmailLogin from "./components/auth/LogIn/UserEmailLogin.js";
import ForgotPasswordEmail from "./components/auth/ForgotPassword/ForgotPasswordEmail.js";
import SetNewPassword from "./components/auth/ForgotPassword/SetNewPassword.js";
import ReferAndEarn from "./dashboard/ReferAndEarn.js";
import PaymentDemo from "./components/pages/PaymentDemo.js";
import ReferAndEarnIndex from "./components/pages/ReferAndEarn/ReferAndEarnIndex.js";

function FilesWrapper() {
  return (
    <UserProvider>
      <Files />
    </UserProvider>
  );
}

function App() {
  return (
    <div>
      <Routes>
        <Route path="*" element={<NotFound />}></Route>
        <Route path="/" element={<HomePage />}></Route>
        {/* <Route path="/dashboard" element={<Dashboard />}></Route> */}
        <Route path={paths.dashboard.root} element={<MegaMenuView />}>
          <Route index element={<DashHome />} />
          <Route path={paths.dashboard.home} element={<DashHome />} />
          <Route path={paths.dashboard.dashSupport} element={<DashSupport />} />
          <Route path={paths.dashboard.dashProfile} element={<DashProfile />} />
          <Route path={paths.dashboard.dashPlans} element={<DashPlans />} />
          <Route
            path={paths.dashboard.referAndEarn}
            element={<ReferAndEarn />}
          />
          {/* Add more routes for other components */}
        </Route>
        {/* <Route path="/" element={<Landingpage />}></Route> */}
        {/* <Route path="/pricing" element={<Pricing />}></Route> */}
        {/* <Route path="/aboutcompany" element={<AboutCompany />}></Route> */}
        {/* <Route path="/signup" element={<Signup />}></Route> */}
        <Route path="/user_Login" element={<UserEmailLogin />}></Route>
        <Route path="/user_signup" element={<EmailAndOtp />}></Route>
        <Route path="/demo" element={<PaymentDemo />}></Route>
        <Route path="/user_pass" element={<UserPass />}></Route>
        <Route path="/refer_and_earn" element={<ReferAndEarnIndex />}></Route>
        <Route
          path="/user_forgot_pass"
          element={<ForgotPasswordEmail />}
        ></Route>
        <Route path="/set_new_password" element={<SetNewPassword />}></Route>
        {/* <Route path="/signupplan" element={<SignupPlan />}></Route> */}
        {/* <Route path="/childsignup" element={<ChildSignup />}></Route> */}
        <Route path="/plans" element={<Plans />}></Route>
        {/* <Route path="/login" element={<Login />}></Route> */}
        {/* <Route path="/otplogin" element={<OtpLogin />}></Route> */}
        {/* <Route
          path="/resetpassword/:token/:emailId"
          element={<Reset />}
        ></Route> */}
        {/* <Route path="/forgotpassword" element={<Forgot />}></Route> */}
        <Route path="/snackbar" element={<CustomSnackbar />}></Route>
        {/* <Route
          path="/activateUser/:token/:emailId/:name"
          element={<Activateuser />}
        ></Route> */}
        <Route path="/carrer" element={<Carrer />}></Route>
        {/* <Route path="/cloudservice" element={<CloudService />}></Route> */}
        {/* <Route path="/product" element={<ProductPage />}></Route> */}
        <Route path="/home" element={<Home />}></Route>
        <Route path="/paymenthome" element={<PaymentHome />}></Route>
        {/* <Route path="/overview" element={<Overview />}></Route> */}
        {/* <Route path="/support" element={<Support />}></Route> */}
        {/* <Route path="/profile" element={<Profile />}></Route> */}
        <Route path="/swiper" element={<TrendingSwiper />}></Route>
        {/* <Route path="/exedownload" element={<DownloadExe />}></Route> */}

        {/* <Route path="/packages" element={<Packages />}></Route> */}
        {/* <Route
          path="/customizepackages/:categoryChecked"
          element={<CustomizePackages />}
        ></Route> */}
        {/* <Route path="/checkout" element={<Checkout />}></Route> */}
        {/* <Route path="/buffer" element={<Buffer />}></Route> */}
        {/* <Route path="/deleteaccount" element={<Deleteaccount/>}></Route> */}
        {/* <Route path="/status" element={<Status />}></Route> */}
        {/* <Route path="/fileshome" element={<Files />}></Route> */}
        {/* <Route path="/files" element={<div className="App"><Files /></div>}></Route> */}
        {/* <Route path="/files" element={<FilesWrapper />} /> */}
        <Route path="/favorites" element={<Favorites />}></Route>
        <Route path="/recyclebin" element={<RecycleBin />}></Route>
        <Route path="/contactus" element={<Contactus />}></Route>
        <Route path="/shipping" element={<Shipping />}></Route>
        {/*<Route path="/decidingscreen" element={<DecidingScreen />}></Route>*/}
        <Route
          path="/cancellation&refundpolicy"
          element={<Cancellation />}
        ></Route>
        <Route path="/terms&condition" element={<Termscondition />}></Route>
        <Route path="/privacy" element={<Privacy />}></Route>
        <Route path="/helpcenter" element={<HelpCenter />}></Route>
        {/* <Route path="/customertestimonials" element={<Testominal />}></Route> */}
        {/* <Route path="/blogsandupdates" element={<BlogsAndUpdates />}></Route> */}
        {/* <Route path="/Selectplan" element={<SelectPlan />}></Route> */}
        {/* <Route path="/addressdetails" element={<AddressDetails />}></Route> */}
        <Route path="/payment" element={<Payment />}></Route>
        <Route path="/paymentplan" element={<PaymentPlan />}></Route>
        <Route path="/downloadwin" element={<DownloadWindow />}></Route>
        <Route path="/paymentproceed" element={<PaymentProceed />}></Route>
        {/* <Route path="/confirmation" element={<Confirmation />}></Route> */}
        {/* <Route path="/vinaykumar" element={<VinayKumar />}></Route> */}
        {/* <Route path="/prabhu" element={<Prabhu />}></Route> */}
        {/* <Route
          path="/parentInformation"
          element={<ParentInformation />}
        ></Route> */}
      </Routes>

      {/* <Link to="/Login">
          <Button variant="contained">Login</Button>
        </Link> 

        <Outlet /> */}
    </div>
    // <div className="App">
    //   <header className="App-header">

    //     <Link to="/Login">Blogs</Link>

    //     <Outlet/>

    //   </header>
    // </div>
  );
}

export default App;
